module.exports = __webpack_public_path__ + "tzgg.png?5f85a55ef5ed81f5aff6b29a594a23f8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tzgg.png
// module id = 633
// module chunks = 0